/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardResponseDto { 
    numberOfOrganisationUsers?: number;
    numberOfFamilies?: number;
    numberOfMembers?: number;
    numberOfDonations?: number;
    numberOfKids02?: number;
    numberOfKids35?: number;
    numberOfKids612?: number;
    numberOfKids1214?: number;
    numberOfKids014?: number;
    numberOfKids016?: number;
    numberOfKids017?: number;
    numberOfKids018?: number;
}

